<div class="main px-5">
  <div class="col-12 mt-3 py-2 px-5 bg-light-color" [class.d-none]="route.children.length !== 0">
    <div class="row row-cols-1 row-cols-sm-2 py-4">
      <div class="col-12 d-flex mt-3 justify-content">
        <div class="col d-flex align-items-center">
          <h1 class="fs-4 fw-bold text-primary-color my-0">{{ titulo == 'Grupo' ? 'Grupo de Correspondência' : titulo }}
          </h1>
        </div>
      </div>
      <div class="col d-flex justify-content-sm-end align-items-center">
        <button nz-button type="button" nzType="primary" [nzSize]="size" class="rounded-pill" (click)="novo()">
          Adicionar Domínio
        </button>
      </div>
    </div>

    <nz-divider class="m-0 p-0 mb-4 mt-4"></nz-divider>

    <div class="d-flex">
      <div class="col-12 contrato-content pl-0 pr-0 border-gray box-shadow">
        <div #contratoContainer>

          <form [formGroup]="dominioFilterForm" id="dominiosFilterForm" (ngSubmit)="pesquisar()">
            <div class="row g-2">

              <ng-container *ngIf="nomeDominio != 'CARGO_TIPO_ENTIDADE'">
                <div class="form-group">
                  <label for="nome" class="form-label">Nome</label>
                  <input nz-input placeholder="Nome" [nzSize]="size" name="nome" formControlName="nome" />
                </div>
              </ng-container>
              <ng-container *ngIf="nomeDominio == 'CARGO_TIPO_ENTIDADE'">

                <div class="col-12 col-sm-4 form-group">
                  <label for="cargoReferencia" class="form-label">Cargo Referência</label>
                  <nz-select id="cargoReferencia" nzShowSearch nzServerSearch nzPlaceHolder="Pesquise nome do cargo"
                    formControlName="cargoReferencia" [nzShowArrow]="false" [nzFilterOption]="nzFilterOption"
                    nzSize="large" [nzAllowClear]="true">
                    <nz-option *ngFor="let item of cargoReferenciaList" [nzValue]="item.id"
                      [nzLabel]="item.nomeCargoReferencia">
                    </nz-option>
                  </nz-select>
                </div>
                <!-- <div class="col-12 col-sm-4 form-group">
                <label for="cargoSubordinadoId" class="form-label">Cargo subordinado:</label>
                <nz-select formControlName="cargoSubordinadoId" nzShowSearch nzAllowClear nzPlaceHolder="-"
                  nzSize="large" nzPlaceHolder="Pesquise nome do cargo">
                  <nz-option [nzValue]="item.id" [nzLabel]="item.nomeCargoReferencia"
                    *ngFor="let item of cargoReferenciaList" />
                </nz-select>
              </div> -->

                <div class="col-12 col-sm-4 form-group">
                  <label for="tipoEntidade" class="form-label">Tipo de entidade</label>
                  <nz-select formControlName="tipoEntidade" nzShowSearch nzAllowClear nzPlaceHolder="Tipo de entidade"
                    nzSize="large">
                    <nz-option [nzValue]="item.id" [nzLabel]="item?.nomeTipoEntidade"
                      *ngFor="let item of tipoEntidadeList" />
                  </nz-select>
                </div>
              </ng-container>

              <ng-container *ngIf="nomeDominio == 'SUB_TIPO_ENTIDADE'">
                <div class="col-12 col-sm-6 form-group">
                  <label for="idTipoEntidade" class="form-label">Tipo de entidade</label>
                  <nz-select formControlName="idTipoEntidade" nzShowSearch nzAllowClear nzPlaceHolder="Tipo de entidade"
                    nzSize="large">
                    <nz-option [nzValue]="item.id" [nzLabel]="item?.nomeTipoEntidade"
                      *ngFor="let item of tipoEntidadeList" />
                  </nz-select>
                </div>

                <div class="col-12 col-sm-6 form-group">
                  <label for="idEspecificacao" class="form-label">Tipo de Órgão</label>
                  <nz-select formControlName="idEspecificacao" nzShowSearch nzAllowClear
                    nzPlaceHolder="Tipo de entidade" nzSize="large" nzMode="multiple">
                    <nz-option [nzValue]="item.id" [nzLabel]="item?.nome"
                      *ngFor="let item of especializacaoSubtipoList" />
                  </nz-select>
                </div>


              </ng-container>

              <div class="col-12 col-sm-6 d-flex align-items-end">
                <label nz-checkbox formControlName="incluirInativos">
                  Incluir Inativos
                </label>
              </div>

              <div class="col-12 d-flex justify-content-between my-4">
                <div class="col">
                  <button nz-button nzType="default" nzSize="large"
                    class="d-flex justify-content-center fw-semibold rounded-3 fs-6" type="button" (click)="voltar()">
                    Voltar
                    <span class="fs-3 ms-2 mdi--search"></span>
                  </button>
                </div>
                <button nz-button nzType="primary" nzSize="large" class="rounded-pill" type="submit"
                  form="dominiosFilterForm">
                  Pesquisar
                </button>
                <button nz-button type="button" nzType="default" [nzSize]="size" class="rounded-pill ms-2"
                  (click)="resetForm()">
                  Limpar
                </button>
              </div>
              <!-- <div class="form-group d-flex justify-content-end ml-3">
              <button nz-button type="button" nzType="default" [nzSize]="size" class="rounded-pill mt-4"
                form="dominioFilterForm" (click)="pesquisar()">
                Pesquisar
              </button>
            </div> -->
            </div>
          </form>

          <nz-divider class="m-0 p-0 mt-4"></nz-divider>

          <div class="d-flex flex-column page-content border border-radius w-100">
            <nz-table [nzData]="dataSet" [nzSize]="'small'" [nzFrontPagination]="false" [nzShowPagination]="false"
              (nzQueryParams)="sort($event)" [nzFooter]="footerTemplate" [nzNoResult]="semDadosTemplate"
              [nzScroll]="{ x: 'fit-content', y:'800px' }">
              <thead>
                <tr>
                  <th *ngIf="colunasVisiveis.includes('id')" nzColumnKey="id" nzShowSort [nzSortFn]="true">ID</th>
                  <th *ngIf="colunasVisiveis.includes('nome')" nzColumnKey="nome" nzShowSort [nzSortFn]="true"
                    style="min-width: 50px; max-width: 400px;">
                    Nome
                  </th>
                  <th *ngIf="colunasVisiveis.includes('nomeCargoReferencia')" nzColumnKey="nomeCargoReferencia"
                    nzShowSort [nzSortFn]="true">Cargo Referência</th>
                  <!-- <th *ngIf="colunasVisiveis.includes('cargoSubordinadoId')" nzColumnKey="cargoSubordinadoId" nzShowSort [nzSortFn]="true">Cargo Subordinado</th> -->
                  <th *ngIf="colunasVisiveis.includes('codigoPai')" nzColumnKey="codigoPai" nzShowSort
                    [nzSortFn]="true">Código Pai</th>
                  <th *ngIf="colunasVisiveis.includes('tipoEntidade')" nzColumnKey="tipoEntidade" nzShowSort
                    [nzSortFn]="true">Tipo Entidade</th>
                  <th *ngIf="colunasVisiveis.includes('nivelHierarquico')" nzColumnKey="nivelHierarquico" nzShowSort
                    [nzSortFn]="true">Nivel Hierárquico</th>
                  <th *ngIf="colunasVisiveis.includes('tipoCargo')" nzColumnKey="tipoCargo" nzShowSort
                    [nzSortFn]="true">
                    {{ nomeDominio == 'CARGO_REFERENCIA' ? 'Suplente' : 'Tipo do Cargo' }}
                  </th>
                  <th *ngIf="colunasVisiveis.includes('tipoGrupo')" nzColumnKey="tipoGrupo" nzShowSort
                    [nzSortFn]="true">Tipo do Grupo</th>
                  <th *ngIf="colunasVisiveis.includes('telasPermitidas')" nzColumnKey="telasPermitidas">Exibidos nas
                    telas</th>
                  <th *ngIf="colunasVisiveis.includes('dataCadastro')" nzColumnKey="dataCadastro">Data Cadastro</th>
                  <th *ngIf="colunasVisiveis.includes('dataInativo')" nzColumnKey="dataInativo">Data Inativo</th>
                  <th *ngIf="colunasVisiveis.includes('sigiloso')" nzColumnKey="sigiloso" nzShowSort [nzSortFn]="true">
                    sigiloso</th>
                  <th *ngIf="colunasVisiveis.includes('cargosAssociados')" nzColumnKey="cargosAssociados">Tipo de
                    Entidades
                    associadas</th>

                  <th *ngIf="colunasVisiveis.includes('nomeSubTipoEntidade')" nzColumnKey="nomeSubTipoEntidade"
                    nzShowSort [nzSortFn]="true">Nome do SubTipo
                  </th>
                  <th *ngIf="colunasVisiveis.includes('especificacoesStr')" nzColumnKey="especificacoesStr">
                    Tipo de Órgão</th>


                  <th *ngIf="colunasVisiveis.includes('nomeTipoEntidade')" nzColumnKey="nomeTipoEntidade" nzShowSort
                    [nzSortFn]="true">Tipo da Entidade Associado ao SubTipo</th>

                  <th *ngIf="colunasVisiveis.includes('nomeSubTipoAssociado')" nzColumnKey="nomeSubTipoAssociado">
                    Sub Tipo associado</th>
                  <th *ngIf="colunasVisiveis.includes('existeCargosAssociados')" nzColumnKey="existeCargosAssociados"
                    nzShowSort [nzSortFn]="true">
                    Cargos Associados</th>
                  <th class="text-center" nzFixed="right" style="width: 80px;">
                    Ações
                  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="paginator?.paginaAtual">
                  <tr *ngFor="let item of dataSet" [ngClass]="item.dataInativo ? 'text-red' : ''">
                    <td *ngIf="colunasVisiveis.includes('nome')"
                      style="white-space: normal; word-break: break-word; max-width: 400px;">
                      {{ item?.nome }}
                    </td>
                    <td *ngIf="colunasVisiveis.includes('nomeCargoReferencia')">{{
                      item?.cargoReferencia?.nomeCargoReferencia}}</td>
                    <!-- <td *ngIf="colunasVisiveis.includes('cargoSubordinadoId')">{{item.cargoSubordinado?.nomeCargoReferencia }}</td> -->
                    <td *ngIf="colunasVisiveis.includes('tipoEntidade')">{{item?.tipoEntidade?.nomeTipoEntidade}}</td>
                    <td *ngIf="colunasVisiveis.includes('nivelHierarquico')">{{item?.nivelHierarquico}}</td>


                    <td *ngIf="colunasVisiveis.includes('tipoCargo')">
                      {{ nomeDominio == 'CARGO_REFERENCIA' ? (item.tipoCargo == 'Suplente' ? 'Sim' : '') :
                      item.tipoCargo }}
                    </td>
                    <td *ngIf="colunasVisiveis.includes('tipoGrupo')"> {{ item?.tipoGrupo?.nomeTipoGrupo || '' }}</td>
                    <td *ngIf="colunasVisiveis.includes('telasPermitidas')">{{
                      transformarListaEmString(item?.telasPermitidas?? []) }}</td>
                    <td *ngIf="colunasVisiveis.includes('dataCadastro')">{{ item.dataCadastro | brDate }}</td>
                    <td *ngIf="colunasVisiveis.includes('dataInativo')">{{ item.dataInativo | date: 'dd/mm/yyyy'}}</td>
                    <td *ngIf="colunasVisiveis.includes('sigiloso')">{{ item.sigiloso ? 'Sim' : 'Não' }}</td>
                    <td *ngIf="colunasVisiveis.includes('cargosAssociados')" style="min-width: 420px;">
                      <app-associacoes-badges-nz [valor]="item.cargosAssociados" [maxVisiveis]="4">
                      </app-associacoes-badges-nz>
                    </td>

                    <td *ngIf="colunasVisiveis.includes('nomeSubTipoEntidade')">{{ item?.nomeSubTipoEntidade }}</td>
                    <td *ngIf="colunasVisiveis.includes('especificacoesStr')">
                      <ng-container *ngFor="let esp of item?.especificacoesStr?.split(',')">
                        <nz-tag [nzColor]="'orange'" class="me-1 mb-1">
                          {{ esp.trim() }}
                        </nz-tag>
                      </ng-container>
                    </td>


                    <td *ngIf="colunasVisiveis.includes('nomeTipoEntidade')">{{ item?.nomeTipoEntidade }}</td>

                    <td *ngIf="colunasVisiveis.includes('nomeSubTipoAssociado')" style="min-width: 420px;">
                      <ng-container *ngFor="let st of item.subTipos">
                        <nz-tag [nzColor]="st.possuiCargos ? 'orange' : 'default'" class="me-1 mb-1">
                          {{ st.nomeSubTipo }}
                        </nz-tag>
                      </ng-container>
                    </td>

                    <td *ngIf="colunasVisiveis.includes('existeCargosAssociados')">{{ item?.existeCargosAssociados ?
                      'Sim' : 'Não' }}</td>


                    <td class="text-center" nzFixed="right" style="width: 80px;">
                      <ng-container *ngIf="item?.nomeSubTipoEntidade != 'Default'">
                        <button nz-button type="button" nz-dropdown [nzDropdownMenu]="menu">
                          <span nz-icon nzType="more" nzTheme="outline"></span>
                        </button>
                      </ng-container>
                      <nz-dropdown-menu #menu="nzDropdownMenu">
                        <ul nz-menu>
                         <li *ngIf="!item.dataInativo" nz-menu-item type="button" (click)="editar(item)">
                            <a>Editar</a>
                          </li>
                          <li nz-menu-item type="button" (click)="inativar(item)">
                            <a>{{ item.dataInativo ? 'Ativar' : 'Inativar' }}</a>
                          </li>
                        </ul>
                      </nz-dropdown-menu>
                    </td>

                  </tr>
                </ng-container>
              </tbody>
            </nz-table>
            <ng-template #footerTemplate>
              <section class="d-flex justify-content-end w-100">
                <app-pagination [itemPorPagina]="10"></app-pagination>
              </section>
            </ng-template>
            <ng-template #semDadosTemplate>
              <div class="d-flex align-items-center justify-content-center" *ngIf="!dataSet?.length">
                <nz-empty [nzNotFoundContent]="'Nenhum registro encontrado'"></nz-empty>
              </div>
            </ng-template>
          </div>
        </div>
        <div class="d-flex w-100 justify-content-end align-items-center mt-3">
          <ng-template *ngxPermissionsOnly="[perfilEnum.Administrador, perfilEnum.Validador]">
            <eds-popover class="menu-exportar-actions" targetClass="exportar-actions" position="bottom">
              <td class="text-center">
                <button nz-button nz-dropdown [nzDropdownMenu]="menu" nzType="primary" [nzSize]="size" nzShape="circle">
                  <span nz-icon nzType="download"></span>
                </button>
                <nz-dropdown-menu #menu="nzDropdownMenu">
                  <ul nz-menu>
                  </ul>
                </nz-dropdown-menu>
              </td>
            </eds-popover>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
<div>
  <router-outlet></router-outlet>
</div>